import React from 'react';
import { useSelector } from 'react-redux';
import styles from './ProfileStyles.module.scss';

const SECTIONS = [
    { id: 'overview', label: 'Account Overview', icon: '👤' },
    { id: 'account', label: 'Manage Account', icon: '⚙️' },
    { id: 'roompin', label: 'Room PIN', icon: '🔑', requiresRoomPin: true },
    { id: 'games', label: 'My Games', icon: '🎮' },
    { id: 'codes', label: 'Redeemed Codes', icon: '🎟️' },
    { id: 'purchases', label: 'Purchase History', icon: '💳' },
];

const ProfileSidebar = ({ activeSection, onSectionChange }) => {
    const { profile } = useSelector(state => state.profile);

    const visibleSections = SECTIONS.filter(section => {
        if (section.requiresRoomPin) {
            return profile?.hasRoomPin;
        }
        return true;
    });

    return (
        <aside className={styles.sidebar}>
            <h2 className={styles.sidebarTitle}>My Account</h2>
            <ul className={styles.navList}>
                {visibleSections.map(section => (
                    <li key={section.id} className={styles.navItem}>
                        <button
                            className={`${styles.navButton} ${activeSection === section.id ? styles.active : ''}`}
                            onClick={() => onSectionChange(section.id)}
                        >
                            <span className={styles.navIcon}>{section.icon}</span>
                            {section.label}
                        </button>
                    </li>
                ))}
            </ul>
        </aside>
    );
};

export default ProfileSidebar;
export { SECTIONS };
